import axios from 'axios';
import { API_URL } from './common';
import { User } from '../models/user';

const getUser = async (id: string): Promise<User> => {
  try {
    const response = await axios.get(`${API_URL}/api/v1/user/me/${id}`);
    return response.data;
  } catch (error: any) {
    console.error('Get user error:', error.response?.data || error.message);
    throw error;
  }
};

const getUsers = async (): Promise<User[]> => {
  try {
    const response = await axios.get(`${API_URL}/api/v1/user/all`);
    return response.data;
  } catch (error: any) {
    console.error(
      'Get all users error:',
      error.response?.data || error.message
    );
    throw error;
  }
};

const updateUser = async (updateUser: User): Promise<User> => {
  try {
    const response = await axios.put(
      `${API_URL}/api/v1/user/${updateUser.id}/update`,
      updateUser
    );
    return response.data;
  } catch (error: any) {
    console.error('Update user error:', error.response?.data || error.message);
    throw error;
  }
};

const deleteUser = async (id: number): Promise<void> => {
  try {
    const response = await axios.delete(`${API_URL}/api/v1/user/${id}/delete`);
    return response.data;
  } catch (error: any) {
    console.error('Delete user error:', error.response?.data || error.message);
    throw error;
  }
};

const userService = {
  getUser,
  getUsers,
  updateUser,
  deleteUser,
};

export default userService;
